import { ParamsProps } from './Params.types'
import { ParamsRoot } from './Params.styles'
import React from 'react'

const Params = ({ children, ...props }: ParamsProps) => {
    return <ParamsRoot {...props}>{children}</ParamsRoot>
}

export default Params
